import VoteSlider from './VoteSlider';

export default VoteSlider;
